import React from 'react'
import { ShimmerTable } from "react-shimmer-effects"

const TableShimmer = ({row, col}) => {
  return (
    <ShimmerTable row={row} col={col} />
  )
}

export default TableShimmer